module.exports = __webpack_public_path__ + "static/media/3.1 KC Tribunj 1-14.08.2025. – kopija.85f67bec.png";